var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 36,
    viewBox: "0 0 60 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 0H2.4C1.07452 0 0 1.07452 0 2.4V33.6C0 34.9255 1.07452 36 2.4 36H57.6C58.9255 36 60 34.9255 60 33.6V2.4C60 1.07452 58.9255 0 57.6 0Z",
    fill: "#26337A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8945 23.7277L26.7394 12.2832H29.6883L27.8436 23.7277H24.8945Z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.54 12.5642C37.9569 12.3345 37.0399 12.084 35.8976 12.084C32.982 12.084 30.9297 13.6371 30.9127 15.8609C30.8941 17.506 32.3772 18.4234 33.4953 18.9701C34.6444 19.5306 35.0305 19.8892 35.0259 20.3904C35.018 21.1568 34.1087 21.508 33.2608 21.508C32.0802 21.508 31.4529 21.3351 30.4831 20.9079L30.1038 20.7257L29.6914 23.2874C30.379 23.6062 31.6538 23.8829 32.9768 23.8974C36.0753 23.8974 38.0887 22.3631 38.1123 19.9883C38.1229 18.6838 37.3371 17.6951 35.6353 16.8787C34.6047 16.348 33.9723 15.9965 33.9795 15.4594C33.9802 14.9838 34.5138 14.4745 35.6688 14.4745C36.6334 14.459 37.3317 14.6817 37.8758 14.9143L38.1406 15.0451L38.54 12.5642Z",
    fill: "#FFFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4663 19.6702C42.7107 19.0124 43.641 16.4713 43.641 16.4713C43.6238 16.5015 43.8841 15.8084 44.033 15.3794L44.232 16.3665C44.232 16.3665 44.7979 19.0981 44.9144 19.6702H42.4663ZM46.1044 12.2949H43.8254C43.1185 12.2949 42.5894 12.4974 42.2797 13.2436L37.9004 23.7318H40.9977C40.9977 23.7318 41.503 22.3208 41.6177 22.0112C41.9556 22.0112 44.9652 22.0171 45.3948 22.0171C45.4832 22.4165 45.7539 23.7318 45.7539 23.7318H48.4909L46.1044 12.2949Z",
    fill: "#FFFFFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4202 12.293L19.5338 20.0953L19.2247 18.5093C18.6868 16.6819 17.0125 14.7013 15.1396 13.7088L17.7802 23.7178L20.9012 23.716L25.5452 12.293H22.4202Z",
    fill: "#FFFFFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8542 12.2852H12.0987L12.0596 12.5223C15.7599 13.4703 18.2082 15.7586 19.2244 18.5093L18.191 13.2507C18.0127 12.5255 17.4946 12.3105 16.8542 12.2852Z",
    fill: "#EC982D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.3f1bd61b49e77b617bd897e5107a5ce0.svg";
export { ForwardRef as ReactComponent };